import classNames from 'classnames';
import { Button, ButtonProps, Tooltip } from 'antd';
import { StarOutlined } from '@ant-design/icons';
import { useSelfContext } from '@/context';
import { useDevice } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { Flex } from '../common';

export function RateButton({ onClick, size, className, ...rest }: ButtonProps) {

  const { isDesktop } = useDevice();
  const { currentSelf } = useSelfContext();
  const [t] = useTranslation(['common']);

  if (!currentSelf) return <></>;

  const renderedButton = (
    <Button
      size={size}
      onClick={onClick}
      className={classNames(
        'leading-[0]',
        { '!h-[28px] !px-2': size === 'small' },
        className,
      )}
      {...rest}
    >
      <StarOutlined className={classNames('leading-[0]', size === 'small' ? 'text-base' : 'text-lg')} />
    </Button>
  );

  return (
    <Flex className="leading-[0]" align="center">
      {isDesktop() ? (
        <Tooltip title={t('common:labels.poll')} placement="bottomLeft">
          {renderedButton}
        </Tooltip>
      ) : renderedButton}
    </Flex>
  );
}

export default RateButton;
